"use client";

import type { Context, PropsWithChildren } from "react";
import React, { useContext, useState } from "react";
import type { VariantType } from "@shared/graphql.types";
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils";

type LandingPageContextType = {
  ctVariants?: VariantType[];
  pageId: string;
  ATBConfirmation: boolean;
  setATBConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
  quickShopTracking: CMSPageProps | null;
  setQuickShopTracking: React.Dispatch<React.SetStateAction<CMSPageProps>>;
  featuredProductSku?: string;
};

const LandingPageContext = React.createContext<
  LandingPageContextType | Record<string, unknown>
>({});

type Props = {
  pageId: string;
  variants: VariantType[] | [];
  featuredProductSku?: string;
};

export const LandingPageProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  pageId,
  variants,
  featuredProductSku
}) => {
  const [ATBConfirmation, setATBConfirmation] = useState(false);
  const [quickShopTracking, setQuickShopTracking] =
    useState<CMSPageProps | null>(null);

  return (
    <LandingPageContext.Provider
      value={{
        ctVariants: variants,
        ATBConfirmation,
        setATBConfirmation,
        featuredProductSku,
        pageId,
        quickShopTracking,
        setQuickShopTracking
      }}
    >
      {children}
    </LandingPageContext.Provider>
  );
};

export const useLandingPageContext = (): LandingPageContextType =>
  useContext(LandingPageContext as Context<LandingPageContextType>);
